export default "__VITE_ASSET__DpwL2EFb__"